import EventList from './EventList';

export default EventList;
export type { EventListProps } from './EventList';
